import { Volume } from '@paradigm/features/src/leaderboard/entities/volume';
import { useVolumesListState } from '@paradigm/features/src/leaderboard/contexts/volumes-list';
import LeaderboardTable from '#/components/Leaderboard/shared/leaderboard-table/LeaderboardTable';
import useColumns from './useColumns';

export default function VolumeTable() {
  const { volumes, status } = useVolumesListState();

  const { columns } = useColumns();

  return (
    <LeaderboardTable<Volume>
      data={volumes}
      status={status}
      columns={columns}
      data-testid="leaderboard-volumes-table"
    />
  );
}
